
export default {
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
  },
  mounted() {
    this.$nextTick(() => {
      // create
      const mm = this.$gsap.matchMedia(this.$refs.container)

      // add a media query. When it matches, the associated function will run
      mm.add('(min-width: 1024px)', () => {
        this.$gsap.set(['.E', '.S', '.G'], {
          opacity: 0,
        })

        const tl = this.$gsap.timeline({
          scrollTrigger: {
            trigger: this.$refs.container,
            // pin: true,
            start: 'center bottom',
            end: 'center center',
            // markers: true,
            // scrub: true,
          },
        })
        tl.from(
          '.path-2',
          {
            y: 200,
            duration: 0.5,
          },
          '>=-.2'
        )
        tl.to('.S', {
          opacity: 1,
          duration: 0.3,
        })
        tl.from(
          '.path-1',
          {
            y: 200,
            duration: 0.5,
          },
          '<=-.2'
        )
        tl.to('.E', {
          opacity: 1,
          duration: 0.3,
        })
        tl.from(
          '.path-3',
          {
            y: 300,
            duration: 0.5,
          },
          '<=-.2'
        )
        tl.to('.G', {
          opacity: 1,
          duration: 0.3,
        })

        tl.to(
          '.path-2',
          {
            opacity: 0.7,
            duration: 0.5,
          },
          '>-=.1'
        )
        tl.to(
          '.path-1',
          {
            opacity: 0.4,
            duration: 0.5,
          },
          '<'
        )
        tl.to(
          '.path-3',
          {
            opacity: 0.2,
            duration: 0.5,
          },
          '<'
        )
      })
    })
  },
}
